<template>
  <div class="conceal-view" :class="isShow ? 'active' : ''" :style="{ 'transform': `translateX(-${xOffset}px)` }" v-loading="loading">
    <div class="list-view list-view-before" :style="{ 'width': `${xOffset}px` }">
      <list-card :cardStyle="cardStyle" :data="item" v-for="(item, index) of beforeList" :key="index"></list-card>
    </div>
    <div class="list-view list-view-center">
      <list-card :cardStyle="cardStyle" :data="data"></list-card>
    </div>
    <div class="list-view list-view-after" :style="{ 'width': `${viewAfterW}px` }">
      <list-card :cardStyle="cardStyle" :data="item" v-for="(item, index) of afterList" :key="index"></list-card>
    </div>

    <div class="company-data">
      <span>同企业产品展开</span>
      <router-link :to="`/company/home/${data.CompID || data.CompId}`" target="_blank" :title="getTextWithRegex(data.CompName || data.PromoteName)" v-html="data.CompName || data.PromoteName"></router-link>
    </div>
  </div>
</template>

<script>
import { TodaySearchService, Message } from "@/service";
import ListCard from "@/components/card-list.vue";

export default {
  components: { ListCard },
  props: {
    data: { default: {} }
  },
  data() {
    return {
      isShow: false,
      loading: false,
      xOffset: 0,
      cardWidth: 0,
      beforeList: [],
      afterList: [],
    }
  },
  computed: {
    cardStyle() {
      return {
        width: `${this.cardWidth}px`
      }
    },
    viewAfterW() {
      return (this.cardWidth * this.afterList.length) + (this.afterList.length * 10);
    }
  },
  methods: {
    async getProduct(params, pageSize, rowIndex) {
      let afterList = [];
      let beforeList = [];
      const res = await TodaySearchService.prodSearch({ ...params, page: 1, pageSize, compId: this.data.CompId });
      if (res.code === 0) {
        const endData = res.data.list.map(item => {
          let newItem = {};
          Object.keys(item).forEach(v => {
            newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
          })
          return newItem;
        }).filter(item => item.ProdId !== this.data.ProdId);

        const afterCount = pageSize - rowIndex - 1;
        afterList = endData.slice(0, afterCount);
        beforeList = endData.slice(afterCount, pageSize - 1);
      }
      this.loading = false;
      return { afterList, beforeList }
    },

    async show(index, params = {}, type = 'click', indexOffset = 0) {
      const viewWidth = document.querySelector('.prod-list-content').clientWidth;
      const listWidth = document.querySelector('.prod-list-block').clientWidth;
      const rowCount = parseInt(viewWidth / listWidth, 10);
      // Number(indexOffset) >= rowCount && (indexOffset = rowCount);
      const rowIndex = (index + indexOffset) % rowCount;
      this.cardWidth = listWidth + 2;
      
      this.loading = true;
      this.isShow = true;
      const { afterList, beforeList } = await this.getProduct(params, rowCount, rowIndex);
      // if (afterList.length <= 0 && beforeList <= 0) {
      //   type === 'click' && (Message.info('暂无更多产品'));
      //   return false;
      // }

      // this.isShow = true;

      let offsetNum = beforeList.length;
      this.xOffset = (listWidth * offsetNum) + (offsetNum * 10) + (offsetNum * 2) + 1;

      this.afterList = afterList;
      this.beforeList = beforeList;
    },
    hide() {
      this.xOffset = 0;
      this.isShow = false;
      this.afterList = [];
      this.beforeList = [];
    },
     getTextWithRegex(html) {
      return html ?  html.toString().replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : html;
    }
  },
}
</script>

<style lang="less" scoped>
.conceal-view{
  position: absolute;
  left: -2px;
  top: -2px;
  height: calc(100% + 4px);
  overflow: hidden;
  width: 0;
  background: #e4e2e2;
  z-index: 5;
  transition: all 0.3s;
  display: flex;
  &.active{
    width: auto;
    max-width: calc(100vw - 46px);
    box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.2);
    border: 2px solid #334161;
  }
  /deep/ .card-btm{
    display: none;
  }
  /deep/ .el-loading-mask{
    background: rgba(214,214,214,0.3);
  }
  /deep/ .card-info{
    background: #e4e2e2;
  }
}
.list-view{
  display: flex;
}
.list-view-before{
  transition: width 0.3s;
  margin-left: -5px;
}
.list-view-center{
  /deep/ .card-info{
    background: #ffffff;
  }
}
.list-view-after{
  transition: width 0.3s;
  margin-right: -5px;
}
.company-data{
  position: absolute;
  left: 0;
  bottom: 0;
  height: 28px;
  line-height: 28px;
  background: #ffffff;
  width: 100%;
  font-size: 14px;
  padding: 0 10px;
  color: #D2963E;
  /deep/ a{
    margin-left: 12px;
    text-decoration: none;
    color: @text-color-base;
  }
  /deep/ a:hover{
    text-decoration: underline;
  }
  /deep/ em{
    font-style: initial;
    color: #dc0000;
  }
}
</style>
